/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Unavailable_MessageInputs */



/**
* | output |
* | --- |
* | "Video filters are not available for YouTube & Vimeo content." |
*
* @param {Video_Filters_Unavailable_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_unavailable_message = /** @type {((inputs?: Video_Filters_Unavailable_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Unavailable_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les filtres video ne sont pas disponibles pour le contenu YouTube et Vimeo.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für YouTube- und Vimeo-Inhalte stehen keine Videofilter zur Verfügung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I filtri video non sono disponibili per i contenuti di YouTube e Vimeo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофильтры недоступны для контента YouTube и Vimeo.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los filtros de vídeo no están disponibles para el contenido de YouTube y Vimeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("YouTube 和 Vimeo 内容不支持视频滤镜功能。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオ フィルターは YouTube および Vimeo コンテンツでは使用できません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("YouTube और Vimeo पर उपलब्ध सामग्री के लिए वीडियो फ़िल्टर उपलब्ध नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os filtros de vídeo não estão disponíveis para conteúdo do YouTube e do Vimeo.")
	return /** @type {LocalizedString} */ ("Video filters are not available for YouTube & Vimeo content.")
});